<button
  type="button"
  class="notification-manager-button"
  (click)="openSidebar()"
  [attr.aria-label]="'notification' | translate"
>
  <svg
    class="stupa-svg notification-bell-icon"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2Zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4a1.5 1.5 0 0 0-3 0v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2Z"
      fill="currentColor"
    />
  </svg>
  <div class="red-dot" *ngIf="unreadCount">{{ displayUnreadCount }}</div>
</button>

<!-- scroll lock is handled manually in the component ([blockScroll]="false") -->
<p-sidebar
  [visible]="sidebarVisible"
  position="right"
  styleClass="notification-panel-sidebar edit-member-container"
  [showCloseIcon]="false"
  [modal]="false"
  [blockScroll]="false"
  (visibleChange)="onSidebarVisibleChange($event)"
>
  <div class="notification-manager-overlay-panel">
    <div class="panel-header">
      <h3 class="panel-title">{{ 'notification' | translate }}</h3>

      <div class="panel-actions">
        <div class="options-action-wrap" *ngIf="notifications.length">
          <button
            type="button"
            class="icon-action"
            [attr.aria-label]="'more_options' | translate"
            (click)="toggleOptionsMenu($event)"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="3" r="1.2" fill="currentColor" />
              <circle cx="8" cy="8" r="1.2" fill="currentColor" />
              <circle cx="8" cy="13" r="1.2" fill="currentColor" />
            </svg>
          </button>
          <div class="options-menu" *ngIf="optionsMenuOpen">
            <button
              type="button"
              class="options-menu-item"
              [disabled]="markAllReadLoading || !hasUnreadNotifications"
              (click)="markAllAsRead()"
            >
              {{ markAllReadLoading ? ('marking' | translate) : ('mark_all_as_read' | translate) }}
            </button>
          </div>
        </div>

        <span class="divider"></span>

        <button
          type="button"
          class="icon-action close-action"
          [attr.aria-label]="'close' | translate"
          (click)="closeSidebar()"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM6.28 5.22C6.13783 5.08752 5.94978 5.0154 5.75548 5.01883C5.56118 5.02225 5.37579 5.10097 5.23838 5.23838C5.10097 5.37579 5.02225 5.56118 5.01883 5.75548C5.0154 5.94978 5.08752 6.13783 5.22 6.28L6.94 8L5.22 9.72C5.14631 9.78866 5.08721 9.87146 5.04622 9.96346C5.00523 10.0555 4.98319 10.1548 4.98141 10.2555C4.97963 10.3562 4.99816 10.4562 5.03588 10.5496C5.0736 10.643 5.12974 10.7278 5.20096 10.799C5.27218 10.8703 5.35701 10.9264 5.4504 10.9641C5.54379 11.0018 5.64382 11.0204 5.74452 11.0186C5.84523 11.0168 5.94454 10.9948 6.03654 10.9538C6.12854 10.9128 6.21134 10.8537 6.28 10.78L8 9.06L9.72 10.78C9.78866 10.8537 9.87146 10.9128 9.96346 10.9538C10.0555 10.9948 10.1548 11.0168 10.2555 11.0186C10.3562 11.0204 10.4562 11.0018 10.5496 10.9641C10.643 10.9264 10.7278 10.8703 10.799 10.799C10.8703 10.7278 10.9264 10.643 10.9641 10.5496C11.0018 10.4562 11.0204 10.3562 11.0186 10.2555C11.0168 10.1548 10.9948 10.0555 10.9538 9.96346C10.9128 9.87146 10.8537 9.78866 10.78 9.72L9.06 8L10.78 6.28C10.9125 6.13783 10.9846 5.94978 10.9812 5.75548C10.9777 5.56118 10.899 5.37579 10.7616 5.23838C10.6242 5.10097 10.4388 5.02225 10.2445 5.01883C10.0502 5.0154 9.86217 5.08752 9.72 5.22L8 6.94L6.28 5.22Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>
    </div>

    <div class="panel-toolbar">
      <div class="filter-tabs">
        <button
          *ngFor="let filter of filters; trackBy: trackByOption"
          type="button"
          class="filter-tab"
          [class.active]="selectedFilter === filter.value"
          (click)="setFilter(filter.value)"
        >
          {{ filter.labelKey | translate }}
        </button>
      </div>

      <div class="panel-controls">
        <div class="select-wrap">
          <select
            [ngModel]="selectedCategory"
            (ngModelChange)="setCategory($event)"
            [attr.aria-label]="'notification_category' | translate"
          >
            <option *ngFor="let category of categories; trackBy: trackByOption" [ngValue]="category.value" class="category-selector-option">
              {{ category.labelKey | translate }}
            </option>
          </select>
        </div>

        <label class="search-field" [attr.aria-label]="'search_notifications' | translate">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M9.917 8.75h-.614l-.218-.21a5.073 5.073 0 1 0-.546.546l.21.218v.614l3.888 3.88 1.16-1.16-3.88-3.888Zm-4.667 0A3.5 3.5 0 1 1 5.25 1.75a3.5 3.5 0 0 1 0 7Z"
              fill="currentColor"
            />
          </svg>
          <input
            type="text"
            [(ngModel)]="searchTerm"
            [placeholder]="'search' | translate"
            (ngModelChange)="onSearchTermChange()"
          />
        </label>
      </div>
    </div>

    <div class="notification-list" (scroll)="onNotificationListScroll($event)">
      @if (notificationsLoading && !notifications.length) {
        <div class="notification-loading" role="status">
          <stupa-skeleton-loader [rows]="5" [columns]="1" />
        </div>
      }

      <div
        *ngFor="let notification of filteredNotifications; trackBy: trackByNotification"
        class="notification-card"
        [class.unread]="notification.status === 'unread'"
        [class.expanded]="isExpanded(notification.listKey)"
        [class.clickable]="notification.actionUrl"
        (click)="openNotification(notification, $event)"
      >
        <div class="notification-icon" [attr.data-accent]="notification.accent">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="4.2" y="3.6" width="11.6" height="12.8" rx="2" stroke="currentColor" stroke-width="1.4" />
            <path d="M7 7h6M7 10h6M7 13h3.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
          </svg>
        </div>

        <div class="notification-content">
          <div class="notification-row">
            <div class="notification-heading-group">
              <h4
                class="notification-title"
                [class.action-link]="notification.actionUrl"
              >
                {{ notification.title }}
              </h4>
              <span class="notification-time">{{ notification.timeAgo }}</span>
            </div>

            <div class="notification-meta" *ngIf="isExpanded(notification.listKey)">
              <button
                *ngIf="notification.showViewMore"
                type="button"
                class="view-more-btn"
                (click)="toggleNotificationDetails(notification); stopPropagation($event)"
              >
                {{ isExpanded(notification.listKey) ? ('view_less' | translate) : ('view_more' | translate) }}
              </button>
            </div>
          </div>

          <p *ngIf="!isExpanded(notification.listKey) && notification.message" class="notification-message">
            {{ notification.message }}
          </p>

          <button
            *ngIf="notification.showViewMore && !isExpanded(notification.listKey)"
            type="button"
            class="view-more-btn bottom-view-more-btn"
            (click)="toggleNotificationDetails(notification); stopPropagation($event)"
          >
            {{ 'view_more' | translate }}
          </button>

        </div>

        <div *ngIf="isExpanded(notification.listKey) && notification.details" class="notification-details-card">
          <h5 class="details-title">{{ notification.details.heading }}</h5>
          <p class="details-copy">{{ notification.details.greeting }}</p>
          <p *ngFor="let paragraph of notification.details.body; trackBy: trackByValue" class="details-copy">
            {{ paragraph }}
          </p>

          <div class="details-signature">
            <p
              *ngFor="let line of notification.details.signature; trackBy: trackByValue"
              class="details-copy signature-line"
            >
              {{ line }}
            </p>
          </div>

          @if (notification.details.attachmentName) {
            <div class="details-divider"></div>

            <div class="details-attachments">
              <p class="attachments-label">{{ 'attachments' | translate }}</p>

              <div class="attachment-row">
                <div class="attachment-chip">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path
                      d="M3.5 1.75h4.375l2.625 2.625v7a.875.875 0 0 1-.875.875H3.5a.875.875 0 0 1-.875-.875v-8.75A.875.875 0 0 1 3.5 1.75Z"
                      stroke="currentColor"
                      stroke-width="1.1"
                      stroke-linejoin="round"
                    />
                    <path d="M7.875 1.75v2.625H10.5" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round" />
                  </svg>
                  <span>{{ notification.details.attachmentName }}</span>
                </div>

                <button type="button" class="download-btn">{{ 'download' | translate }}</button>
              </div>
            </div>
          }
        </div>
      </div>

      @if (loadingMore) {
        <div class="notification-loading notification-loading-more" role="status">
          <stupa-skeleton-loader [rows]="2" [columns]="1" />
        </div>
      }

      <div *ngIf="!notificationsLoading && !loadingMore && !filteredNotifications.length" class="empty-state">
        <div class="empty-state-icon">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path
              d="M6.417 8.708V7.792a4.583 4.583 0 1 1 9.166 0v.916h.459A1.958 1.958 0 0 1 18 10.667v5.5a1.958 1.958 0 0 1-1.958 1.958H5.958A1.958 1.958 0 0 1 4 16.167v-5.5c0-1.081.877-1.959 1.958-1.959h.459Zm1.833 0h5.5V7.792a2.75 2.75 0 1 0-5.5 0v.916Zm-2.292 1.834a.125.125 0 0 0-.125.125v5.5c0 .069.056.125.125.125h10.084a.125.125 0 0 0 .125-.125v-5.5a.125.125 0 0 0-.125-.125H5.958Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <p class="empty-state-title">{{ 'no_notifications_found' | translate }}</p>
        <p class="empty-state-description">{{ 'adjust_filters_check_back_later' | translate }}</p>
      </div>
    </div>
  </div>
</p-sidebar>
